import { z } from 'zod';
import { FlowInputSchemaSchema } from './blocks/inputSchema.js';
import { FlowBlockUnionSchema } from './blocks/union.js';
import { FlowDecorationDataSchema } from './decorations/nodes.js';
import { FlowEdgeSchema } from './edges/edges.js';
/**
 * Validates each block against its own config schema, not just the shared envelope. The inferred
 * type is unchanged either way — both resolve to {@link FlowBlock} — so this is a runtime
 * distinction only.
 */
export const FlowDataSchema = z.object({
    blocks: z.array(FlowBlockUnionSchema),
    edges: z.array(FlowEdgeSchema),
    decorations: FlowDecorationDataSchema.optional(),
    inputSchema: FlowInputSchemaSchema.optional(),
});
//# sourceMappingURL=flowData.js.map